import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c6087b02&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=c6087b02&prod&lang=less"
import style1 from "./App.vue?vue&type=style&index=1&id=c6087b02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6087b02",
  null
  
)

export default component.exports